var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMiniplayerOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  opacity: 0.95
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 6a4 4 0 0 1 4-4h11a4 4 0 0 1 4 4v4a1 1 0 1 1-2 0V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 20h-6a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1m-6 2a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3zM10.207 11.707a1 1 0 0 0 0-1.414L8.414 8.5H9a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-.586l1.793 1.793a1 1 0 0 0 1.414 0"
}))));
export default SvgIcMiniplayerOff;